import { gql } from '@apollo/client';

export const SUBMIT_GAME_IQ_ATTEMPT = gql`
  mutation SubmitGameIQAttempt($input: SubmitGameIQAttemptInput!) {
    submitGameIQAttempt(input: $input) {
      _id
      athlete
      coach
      type
      sport
      level
      scorePercent
      passed
      dateTaken
    }
  }
`;